<template>
  <div class="items">

    <v-toolbar color="transparent" flat>
      <v-toolbar-title>Entities ({{totalItems}})</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-banner>
      An entity represents a <strong>Keyword</strong> or <strong>Ad</strong> in Google Ads that should be paused
      when any of it's URLs is considered broken.
    </v-banner>

    <v-toolbar flat color="transparent">

      <v-spacer></v-spacer>

      <v-menu
        v-model="showFilters"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <template v-slot:activator="{ on }">
          <v-btn
            text
            v-on="on"
            color="primary"
          >
            <v-icon left dark>mdi-filter</v-icon>
            Filter <span v-if="activeFilterCount > 0">({{ activeFilterCount }})</span>
          </v-btn>
        </template>

        <v-card>
          <v-list>
            <v-list-item>

              <v-list-item-content>
                <v-list-item-title>Filter</v-list-item-title>
                <v-list-item-subtitle>Filter entities</v-list-item-subtitle>
              </v-list-item-content>

            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list>

            <v-list-item>

              <v-select
                v-model="filters.state"
                :items="['ok', 'broken', 'pending']"
                label="State"
                clearable
                outlined
                solo
                flat
                dense
              ></v-select>
            </v-list-item>

            <v-list-item>

              <v-select
                v-model="filters.status"
                :items="['paused', 'enabled']"
                label="Status"
                clearable
                outlined
                solo
                flat
                dense
              ></v-select>
            </v-list-item>

          </v-list>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn text @click="showFilters = false">Cancel</v-btn>
            <v-btn color="primary" text @click="applyFilters">Apply</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>

    </v-toolbar>

    <v-data-table
    :headers="headers"
    :items="items"
    :loading="loading"
    :itemsPerPage="25"
    :server-items-length="totalItems"
    :footer-props="{ itemsPerPageOptions: [25] }"
    :options.sync="options"
    disable-sort
    class="elevation-1"
    >

    <template v-slot:item.urls="{ item }">
      <ExternalLink :link="item.primary_url" />
    </template>

    <template v-slot:item.resource_name="{ item }">
      {{ shortResourceName(item.resource_name) }}
    </template>

    <template v-slot:item.min_validated_at="{ item }">
      {{ item.min_validated_at | shortTime }}
    </template>

    <template v-slot:item.state="{ item }">
      <ItemState v-bind="attrs" v-on="on" :status="item.state" />
    </template>

    <template v-slot:item.status="{ item }">
      <RemoteStatus :status="item.status" />
    </template>

    <template v-slot:item.issues="{ item }">
      {{ item.issues.map(iss => iss.type).join(',') }}
    </template>

    </v-data-table>

  </div>
</template>

<script>

import { fetchItems } from '@/api'
import ItemState from '@/components/ItemState.vue'
import ExternalLink from '@/components/ExternalLink.vue'
import RemoteStatus from '@/components/RemoteStatus.vue'

export default {
  name: 'items',
  props: ['projectId'],
  components: { ItemState, ExternalLink, RemoteStatus },
  data () {
    return {
      headers: [
        { text: '#', value: 'id' },
        { text: 'Resource Name', value: 'resource_name' },
        { text: 'Type', value: 'entity_type' },
        { text: 'URLs', value: 'urls' },
        { text: 'Validated at', value: 'min_validated_at' },
        { text: 'Current state', value: 'state', align: 'center', },
        { text: 'Known status', value: 'status' },
        { text: 'Issues', value: 'issues' }
      ],
      loading: false,
      options: {},
      items: [],
      totalItems: 0,
      showFilters: false,
      filters: { status: '', state: '' },
      filterParams: {}
    }
  },

  watch: {
    options: {
      handler: 'getDataFromApi',
      deep: true,
    }
  },

  computed: {

    activeFilterCount () {
      return Object.values(this.filterParams).filter(val => val).length
    }

  },

  methods: {

    shortResourceName (name) {
      return name.split('/').slice(-1)[0]
    },

    applyFilters () {
      let params = {};
      Object.keys(this.filters).forEach(key => {
        const filter = this.filters[key]
        if (filter) {
          params[key] = filter
        }
      });
      this.filterParams = params;
      this.showFilters = false;
      this.getDataFromApi();
    },

    getDataFromApi () {
      this.loading = true
      const { page } = this.options

      const filters = Object.assign({}, this.filterParams)
      const query = Object.assign(filters, {
        page: page
      });

      fetchItems(this.projectId, query).then(data => {
        this.items = data.entries
        this.totalItems = data.total
        this.loading = false
      })
    }

  }

}

</script>

<style>

.state.up { color: green }
.state.unknown { color: grey }
.state.down { color: #FF4136; }

</style>
